import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const {
      className,
      rootClassName,
      geolocation,
      publicData,
      savedLocation,
      listingId,
      mapsConfig,
    } = this.props;

    if (!geolocation) {
      return null;
    }

    const address = publicData?.location?.address || '';
    // Use the original location identity: translated addresses can omit its ID.
    const location = savedLocation || publicData?.location || {};
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? {
          obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey),
          hiddenPlace: {
            id: location.googlePlaceId,
            position: location.googleMapsLocation || geolocation,
          },
        }
      : { address, center: geolocation };

    const map = <Map {...mapProps} mapsConfig={mapsConfig} useStaticMap={this.state.isStatic} />;

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading>

        <p className={css.ingress}>
          <FormattedMessage id="ListingPage.locationDisclaimer" />
        </p>

        <div className={css.map}>
          {map}
          {this.state.isStatic ? (
            <button
              type="button"
              className={css.mapActivate}
              onClick={() => this.setState({ isStatic: false })}
            >
              <span className={css.mapActivateLabel}>
                <FormattedMessage id="ListingPage.locationTitle" />
              </span>
            </button>
          ) : null}
        </div>
      </section>
    );
  }
}

export default SectionMapMaybe;
